<template>
    <div>
        <!-- 指定人员账号personId -> 操作 -->
        <el-link v-if="row.voteStatus === 1" v-text-lbl="'pageBtns.edit'" @click="editMainBusiform()">编辑</el-link>
        <el-link v-if="row.voteStatus !== 1" v-text-lbl="'statistics'" @click="lookInfo(row, 'info')">统计</el-link>
        <el-link v-if="row.voteStatus === 2" v-text-lbl="'topUp'" @click="changeFormTop(row)">置 顶</el-link>
        <el-link v-if="row.isUp === 0 && row.voteStatus !== 3" v-text-lbl="'grounding'" @click="changeFormDelay(row, 1)">上架</el-link>
        <el-link v-if="row.isUp === 1 && row.voteNum == 0 && row.voteStatus !== 3" v-text-lbl="'offShelf'" type="text" @click="changeFormDelay(row, 0)">下架</el-link>
        <el-link v-if="row.voteStatus !== 1" v-text-lbl="'questionnaireCode'" @click="lookInfo(row, 'code')">问卷二维码</el-link>
    </div>
</template>

<script>
export default {
    name: 'VoteBtn',
    components: {},
    props: {
        row: {
            type: Object,
            default: function () {
                return {}
            }
        },
        column: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            i18npkg: 'hygl',
            moduleCode: 'voteManage'
        }
    },
    computed: {},
    watch: {},
    created() {},
    beforeDestroy() {},
    mounted() {},
    methods: {
        // 上架下架
        changeFormDelay(row) {
            const params = JSON.parse(JSON.stringify(row))
            // if ([2].includes(params.voteStatus)) {
            //     params.voteStatus = 4
            // } else if ([1, 4].includes(params.voteStatus)) {
            //     if (new Date(params.endTime) < new Date()) {
            //         params.voteStatus = 3
            //     } else if (new Date(params.startTime) > new Date()) {
            //         params.voteStatus = 1
            //     } else if (new Date(params.startTime) < new Date()) {
            //         params.voteStatus = 2
            //     }
            // }
            params.isUp = !params.isUp
            const _this = this
            _this
                .$http({
                    method: 'PUT',
                    contentType: 'application/json charset=utf-8',
                    url: '/hygl/vote/updateList',
                    data: [params]
                })
                .then((res) => {
                    if (res.code === 'success') {
                        _this.$message.success(res.message)
                        _this.$bus.emit('refreshListData')
                    } else {
                        _this.$message.fail(res.message)
                    }
                })
        },
        // 置顶
        changeFormTop(data) {
            const _this = this
            this.$confirm(this.$tx('hygl.message.topTip', '最近置顶的，将显示在最前面'), this.$tx('hygl.message.confirmTop', '确定置顶？'), {
                confirmButtonText: this.$tx('hygl.common.confirm2', '确 定'),
                cancelButtonText: this.$tx('hygl.common.cancel', '取 消'),
                type: 'warning'
            }).then(() => {
                this.$http({
                    method: 'PUT',
                    contentType: 'application/json charset=utf-8',
                    url: '/hygl/vote/updateVote',
                    data: { id: data.id }
                }).then((res) => {
                    if (res.code === 'success') {
                        _this.$message.success(res.message)
                        _this.$bus.emit('refreshListData')
                    } else {
                        _this.$message.error(res.message)
                    }
                })
            })
        },
        lookInfo(row, type) {
            const _this = this
            _this.$nextTick(function () {
                _this.$bus.emit('openVoteform', row, type)
            })
        },
        editMainBusiform() {
            this.$vnode.context.$vnode.context.moduleInfo.addNew = false
            window.open('#/newBusiForm?voId=' + this.row.id + '&moduleInfo=' + encodeURIComponent(JSON.stringify(this.$vnode.context.$vnode.context.moduleInfo)) + '&title=' + encodeURIComponent(this.$tx('hygl.voteManage.resolutionVoting', '决议投票')) + '&busiInfo=' + encodeURIComponent('会议决议投票') + '&formUrl=hygl.vote.form&innerUrl=&noEdit=false')
        }
    }
}
</script>

<style scoped lang="scss">
</style>
